import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const LockSvg = () => (
  <svg width='21' height='25' viewBox='0 0 21 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_49_5993)'>
      <path
        d='M11.1046 0.775374C11.9012 0.900331 12.6599 1.11915 13.3389 1.54976C14.8636 2.51656 15.7007 3.86352 15.7651 5.62524C15.7853 6.17845 15.7651 9.73343 15.773 10.2872C15.7767 10.4838 15.7026 10.5442 15.504 10.5401C15.0138 10.5299 14.5235 10.5299 14.0332 10.5401C13.8261 10.5448 13.7722 10.4679 13.7703 10.2802C13.7648 9.67183 13.7955 6.06406 13.7421 5.45511C13.6196 4.08879 12.4399 2.90375 10.9887 2.71485C9.46037 2.51539 8.08275 3.21292 7.4442 4.50649C7.234 4.93182 7.16046 5.38647 7.15739 5.84817C7.15004 6.98745 7.16168 8.12732 7.14943 9.2666C7.14943 9.50126 7.21438 9.57049 7.4638 9.5699C10.7906 9.56247 14.1172 9.5609 17.4436 9.56521C18.9922 9.56521 20.1761 10.5185 20.4378 11.9734C20.4594 12.1203 20.4678 12.2687 20.4629 12.4169C20.4629 15.5849 20.4629 18.7528 20.4629 21.9207C20.4629 23.5364 19.176 24.7689 17.4908 24.7695C12.8027 24.7722 8.11462 24.7722 3.42654 24.7695C1.75722 24.7695 0.469684 23.5323 0.467846 21.9313C0.464169 18.7547 0.464169 15.578 0.467846 12.4011C0.467846 10.8001 1.75477 9.5699 3.42716 9.56227C3.90822 9.56227 4.38929 9.54937 4.86974 9.56697C5.11487 9.57518 5.16879 9.48953 5.16695 9.27364C5.15756 8.07921 5.15756 6.88498 5.16695 5.69095C5.18779 3.23932 7.12369 1.14321 9.66506 0.808813C9.72082 0.801773 9.77597 0.785934 9.83113 0.7742L11.1046 0.775374ZM10.4685 11.4718C8.19367 11.4718 5.91889 11.4718 3.6441 11.4718C2.82843 11.4718 2.46258 11.8238 2.46135 12.6035C2.46135 13.6336 2.46135 14.6638 2.46135 15.694C2.46135 17.7156 2.46135 19.737 2.46135 21.7582C2.46135 22.1149 2.53367 22.4434 2.85478 22.6728C3.09685 22.8488 3.38059 22.8676 3.66922 22.8676C8.20164 22.8676 12.7345 22.8676 17.2677 22.8676C17.3979 22.8681 17.5279 22.8577 17.6562 22.8365C18.106 22.7596 18.3561 22.5144 18.4449 22.0856C18.4695 21.9472 18.4797 21.8069 18.4756 21.6667V13.9387C18.4756 13.4623 18.4817 12.9866 18.4756 12.5102C18.4645 11.8461 18.0864 11.4877 17.3921 11.4724C17.3186 11.4724 17.245 11.4724 17.1715 11.4724L10.4685 11.4718Z'
        fill='url(#paint0_linear_49_5993)'
      />
      <path
        d='M10.4323 14.1563C11.229 14.161 11.8908 14.5934 12.166 15.2481C12.4411 15.9028 12.302 16.6625 11.7505 17.1412C11.517 17.3436 11.4496 17.5484 11.4588 17.8294C11.476 18.3521 11.4674 18.8748 11.4625 19.3975C11.4576 19.9613 11.0372 20.3696 10.4697 20.3702C9.90223 20.3708 9.47877 19.9683 9.47326 19.404C9.46774 18.8267 9.46529 18.2488 9.47326 17.6716C9.48059 17.5878 9.46619 17.5036 9.43134 17.4264C9.39648 17.3492 9.34226 17.2815 9.27348 17.2292C8.73542 16.7834 8.52952 16.2061 8.67843 15.5444C8.83654 14.8439 9.30412 14.3969 10.0266 14.2039C10.0811 14.1876 10.1368 14.1758 10.1933 14.1687C10.2944 14.1599 10.3925 14.1581 10.4323 14.1563Z'
        fill='url(#paint1_linear_49_5993)'
      />
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_49_5993'
        x1='0.465088'
        y1='0.7742'
        x2='21.2062'
        y2='1.43359'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_49_5993'
        x1='8.63135'
        y1='14.1563'
        x2='12.4413'
        y2='14.2422'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <clipPath id='clip0_49_5993'>
        <rect width='20' height='24' fill='white' transform='translate(0.467773 0.77536)' />
      </clipPath>
    </defs>
  </svg>
);

export const LockColorIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={LockSvg} {...props} />
);
